<template>
  <div class="trade-last-orders-tabs">
    <div class="trade-last-orders-tabs__desktop txt--color-03">
      <exc-tabs
        :selected-button="typeTab.value"
        :buttons="tabs"
        no-active-item-styles
        no-paddings
        tab-key="value"
        size="xs"
        @change-tab="onClickTab"
      >
        <template #all="{ isActive, label }">
          <component
            :is="label"
            :class="{ 'active bor--main txt--color-05': isActive }"
            class="trade-last-orders-tabs__img bor--all bor--transp-02"
            alt=""
          />
          <!-- <span>
            <img
              :class="{ 'active bor--main': isActive }"
              :src="label"
              class="trade-last-orders-tabs__img bor--all bor--transp-02"
              alt=""
            >
          </span> -->
        </template>
        <template #buy="{ isActive, label }">
          <component
            :is="label"
            :class="{ 'active bor--main txt--color-05': isActive }"
            class="trade-last-orders-tabs__img bor--all bor--transp-02"
            alt=""
          />
          <!-- <span>
            <img
              :class="{ 'active bor--main': isActive }"
              :src="label"
              class="trade-last-orders-tabs__img bor--all bor--transp-02"
              alt=""
            >
          </span> -->
        </template>
        <template #sell="{ isActive, label }">
          <component
            :is="label"
            :class="{ 'active bor--main txt--color-05': isActive }"
            class="trade-last-orders-tabs__img bor--all bor--transp-02"
            alt=""
          />
          <!-- <span>
            <img
              :class="{ 'active bor--main': isActive }"
              :src="label"
              class="trade-last-orders-tabs__img bor--all bor--transp-02"
              alt=""
            >
          </span> -->
        </template>
      </exc-tabs>
    </div>
  </div>
</template>

<script>
import {
  ExcTabs,
  // ExcHeaderNavItem,
  // ExcHeaderDropdownItem,
} from '@/components/common'
import {
  lastOrdersCurrentTab,
  lastOrdersTabs,
  changeCurrentTab,
} from './tradeLastOrdersHelpers.js'

export default {
  name: 'TradeLastOrdersTabs',
  components: {
    ExcTabs,
    // ExcHeaderNavItem,
    // ExcHeaderDropdownItem,
  },
  data () {
    return {
      tabs: lastOrdersTabs,
    }
  },
  computed: {
    typeTab: {
      get () {
        return lastOrdersCurrentTab.tab
      },
      set (v) {
        lastOrdersCurrentTab.tab = v
      },
    },
  },
  methods: {
    onClickTab: changeCurrentTab,
  },
}
</script>

<style lang="scss" scoped>
.trade-last-orders-tabs {
  display: flex;
  align-items: center;

  &::v-deep {
    .exc-tabs__tab {
      // padding: 0 5px;
      padding-right: 5px;

      &:last-child {
        padding-right: 0px;
      }
    }
  }

  &__img {
    border-radius: toRem(3px);
    max-width: toRem(18px);
    max-height: toRem(18px);
    transition-duration: .25s;
  }
}
</style>
